import Field from './Field';
import { createVueApp } from 'larasnap/support';

export default class extends Field {
    constructor(element, parent, props) {
        super(element, parent, props);

        if (this.isEdit()) {
            this.createVueComponent();
        }
    }

    createVueComponent() {
        this._input.hide();
        const startValue = this._input.val().trim();

        createVueApp('MultiInput', {
            field: this.getName(),
            dataProp: 'items',
            startValue,
        }).insertAfter(this._input);
    }

    setValue(value = '') {
        super.setValue(value);
        this.runHandler('set-value', value);
        return this;
    }

    setEnabled(isEnabled) {
        super.setEnabled(isEnabled);
        this.runHandler('set-enabled', isEnabled);
        return this;
    }
}
